export const MENU_PROMO_FIRST_ORDER = 'promo-first-order';
export const MENU_PROMO_SPECIAL_DISCOUNT = 'promo-special-discount';
export const MENU_PROMO_SPECIAL_PROMOCODE = 'promo-special-promocode';

export const PROMO_SECOND_ORDER_PRICE = '2 190';

export const PROMOCODE_TYPES_PERCENT = [1, 3, 5];
export const PROMOCODE_TYPES_FIXED = [0, 2, 6];
